import { mapGetters } from "vuex";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
// import googleMapsService from "../../../api/googleMaps.service";
import moment from "moment";
export default {
  name: "alarms-list",
  components: { pageheader },
  props: [],
  data() {
    return {
      input: {},
      dialog: false,
      selectedAlarm: {},
      alarmType: "OperationalAlerts",
      alarmTypeList: [
        {
          name: "Operational Alerts",
          value: "OperationalAlerts",
        },
        {
          name: "Logistics Alerts",
          value: "LogisticsAlerts",
        },
      ],
      headers: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "sno",
        },
        // { text: "Company Name", value: "customerName" },
        { text: "Name", value: "name" },
        { text: "Type", value: "type" },
        // { text: "Battery Level", value: "batteryLevel" },

        // { text: "Description", value: "description" },
        { text: "Criticality", value: "configurationDetails.criticality" },
        { text: "Created Date", value: "createdAt" },
        { text: "Active", value: "active" },

        { text: "Action", value: "action", width: "120px" },
      ],
      page: 1,
      search: "",
      options: {},
      loading: false,
      alarms: [],
      isdelete: false,
      isFilter: false,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "customerLoggedInCompanyId",
      "customerLoggedInCompanyName",
      "id",
    ]),
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("alerts", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.search = this.$route.query.filterVal;
      this.isFilter = this.$route.query.isFilter;
    }
    this.getAlarms();
  },
  methods: {
    confirmDelete(item) {
      this.dialog = true;
      this.selectedAlarm = item;
    },
    newAlarm() {
      // this.$router.push({
      //   path: "/alarms/add?",
      // });
      this.$router.push({
        name: "Add Alerts",
        params: { type: "OperationalAlerts" },
      });
    },
    newAlarmLogistics() {
      // this.$router.push({
      //   path: "/alarms/add?",
      // });
      this.$router.push({
        name: "Add Alerts",
        params: { type: "LogisticsAlerts" },
      });
    },

    async getAlarms() {
      this.alarms = [];
      this.loading = true;
      try {
        // this.companySelected.id
        console.log(this.alarmType);
        let response = await telematicsService.getAlarmsType();
        if (response && response.data) {
          this.alarms = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async enableAlarmfun(enableAlarmdata) {
      this.isUpdatingstatus = true;
      var response;
      let payload = {
        id: enableAlarmdata.id,
        enabled: enableAlarmdata.enabled,
      };
      try {
        if (this.alarmType == "LogisticsAlerts") {
          response = await telematicsService.updateAlertEnabled(
            String(enableAlarmdata.id),
            payload
          );
        }
        if (this.alarmType == "OperationalAlerts") {
          response = await telematicsService.updateAlertEnabled(
            String(enableAlarmdata.id),
            payload
          );
        }
        if (response.isSuccess) {
          this.$toast.success("Alert status got changes successfully");
          this.isUpdatingstatus = false;
          this.getAlarms();
        } else {
          this.$toast.error(response.systemMessage);
          this.isUpdatingstatus = false;
        }
      } catch (err) {
        this.isUpdatingstatus = false;
        this.$toast.error("Unable to update alarm status" + err);
      }
    },
    async deleteAlarm() {
      try {
        this.isdelete = true;
        var response;
        if (this.alarmType == "OperationalAlerts") {
          response = await telematicsService.deleteAlert(this.selectedAlarm.id);
        }
        if (this.alarmType == "LogisticsAlerts") {
          response = await telematicsService.deleteAlert(this.selectedAlarm.id);
        }
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Alert deleted successfully");
          this.getAlarms();
          this.dialog = false;
          this.selectedAlarm = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Alarm" + err);
      }
    },
    editAlarm(item) {
      let alarmType;
      if (item.configurationDetails.alertType == "OPERATIONAL_ALERT") {
        alarmType = "OperationalAlerts";
      }
      if (item.configurationDetails.alertType == "LOGISTIC_LOGGING_ALERT") {
        alarmType = "LogisticsAlerts";
      }
      if (this.isFilter) {
        this.$router.push({
          name: "Update Alerts",
          params: { id: item.id, type: alarmType },
          query: { filterVal: this.search, isFilter: this.isFilter },
        });
      } else {
        this.$router.push({
          name: "Update Alerts",
          params: { id: item.id, type: alarmType },
          query: { filterVal: "", isFilter: this.isFilter },
        });
      }
    },
    onSearch() {
      if (this.search) {
        this.isFilter = true;
      } else {
        this.isFilter = false;
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/alerts/list`);
      this.getAlarms();
    },
  },
};
